import { callApi } from '@local_modules/generic/fetch.js'
import { enrichChartOfAccounts } from './enrich-charts-of-accounts.js'

export async function associateAccount (cellParams, selectedAccountingOrganisationId) {
  console.log('associateAccount', cellParams, cellParams.data.selectInstance.selectedValue)

  cellParams.data.isLoading = true
  cellParams.api.refreshCells({
    rowNodes: [cellParams.node],
    columns: [cellParams.colDef],
    force: true
  })
  console.log('refresh done')

  await executeAssociation(cellParams, selectedAccountingOrganisationId)

  cellParams.data.isLoading = false
  cellParams.api.refreshCells({
    rowNodes: [cellParams.node],
    columns: [cellParams.colDef],
    force: true
  })
}

/**
 * Pick an entity to associate, or none
 * @param {*} cellParams
 * @param {*} selectedAccountingOrganisationId
 * @returns
 */
async function executeAssociation (cellParams, selectedAccountingOrganisationId) {
  const appAccountId = cellParams.context.browserAppAccount.data.appAccount.id

  const cellAccountingOrganisation = cellParams.colDef.context.accountingOrganisation
  // console.log('cellAccountingOrganisation', cellAccountingOrganisation)

  const selectedChartOfAccount = cellParams.data.valuesByAccountingOrganisationId.get(cellAccountingOrganisation.id)?.[0]
  // console.log('selectedChartOfAccount', selectedChartOfAccount)

  const api = (selectedAccountingOrganisationId === 'none') ? endpoints.disassociation : endpoints.association
  // console.log('api', api)

  const response = await callApi(api.url, {
    appAccountId,
    accountingOrganisationId: selectedAccountingOrganisationId,
    chartOfAccountXeroId: selectedChartOfAccount.xero_id
  }, {
    method: api.method
  })

  updateBrowserData(cellParams, selectedChartOfAccount, response, cellAccountingOrganisation, selectedAccountingOrganisationId)
  // console.log(response)

  cellParams.context.allChartOfAccounts = enrichChartOfAccounts(cellParams.context.allChartOfAccounts, cellParams.context.associatedChartOfAccounts, cellParams.context.browserAppAccount)
  return response
}

function updateBrowserData (cellParams, selectedChartOfAccount, response, cellAccountingOrganisation, selectedAccountingOrganisationId) {
  cellParams.context.associatedChartOfAccounts = cellParams.context.associatedChartOfAccounts.filter(v => v.accounting_chart_of_account_id !== selectedChartOfAccount.id)

  if (selectedAccountingOrganisationId !== 'none') {
    cellParams.context.associatedChartOfAccounts.push({
      in_accounting_organisation_id: cellAccountingOrganisation.id,
      representing_accounting_organisation_id: selectedAccountingOrganisationId,
      accounting_chart_of_account_id: response.accounting_chart_of_account_id
    })
  }
}

const endpoints = {
  association: {
    url: '/api/intercompany/:appAccountId/chart-of-accounts/:chartOfAccountXeroId/associate/:accountingOrganisationId',
    method: 'PUT'
  },
  disassociation: {
    url: '/api/intercompany/:appAccountId/chart-of-accounts/:chartOfAccountXeroId/disassociate',
    method: 'DELETE'
  }
}
